<template>
  <div class="text-center">
    <v-dialog
      :value="dialogJoinBusiness"
      persistent
      transition="dialog-bottom-transition"
      width="600px"
    >
      <v-card
        class="pt-4 pb-8 dialog-select"
        style="border-radius: 24px !important"
      >
        <v-card-title class="pa-0 px-8 justify-end">
          <v-icon large color="#152536" @click="closeDialog">mdi-close</v-icon>
        </v-card-title>
        <div class="text-center pb-4 px-4 px-sm-0">
          <span class="title-text">ยินดีต้อนรับสู่ !</span>
        </div>
        <div class="text-center pb-4 px-4 px-sm-0">
          <span class="title-text">บริษัท {{ data[0].business_name_th }}</span>
        </div>
        <div class="text-center dialog-select">
          <v-img
            class="mb-4"
            :src="businessJoinImage"
            height="220px"
            contain
          ></v-img>
        </div>
        <div class="text-center pb-2 px-4 px-sm-0">
          <span class="sub-title-text"
            >เพิ่มรายละเอียดขององค์กร เพื่อให้คุณเป็นที่รู้จักมากขึ้น หรือ
            เริ่มเข้าใช้งานเพื่อลงประกาศตำแหน่ง
          </span>
        </div>
        <div class="pt-8 mx-sm-10 text-center dialog-select">
          <v-btn
            color="default_button_primary"
            :width="$vuetify.breakpoint.smAndUp ? '200' : ''"
            @click="routeToBusiness"
            rounded
          >
            <b style="color: white">เพิ่มข้อมูลองค์กร</b>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "DialogJoinBusiness",
  props: {
    dialogJoinBusiness: Boolean,
    data: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    return {};
  },
  watch: {},
  created() {},
  methods: {
    closeDialog() {
      this.$store.commit("setBusinessJoin", false);
      this.$emit("clickedCloseDialogJoinSuccess");
    },
    routeToBusiness() {
      this.$emit("clickedCloseDialogJoinSuccess");
      this.$store.commit("setBusinessJoin", false);
      this.$store.commit("setBusiness_Id", this.data[0].business_id);
      this.$store.commit("setBusiness_Name", this.data[0].business_name_th);
      this.$router.push("/business_profile/edit_business_profile");
    },
  },
  computed: {
 
    businessJoinImage() {
      return process.env.VUE_APP_USE_THEME === 'KKU_ADMIN' 
        ? require('@/assets/business_join_kku.png')
        : require('@/assets/business_join.png');
    }
  },
};
</script>
<style scoped>
.dialog-select {
  font-family: Noto Sans Thai !important;
}
.title-text {
  font-size: 20px;
  font-weight: 700;
  color: #333333;
}
.sub-title-text {
  font-size: 14px;
  font-weight: 400;
  color: #636363;
}
.field-input {
  border-radius: 12px;
}
.custom-card {
  border-radius: 12px;
  border: 1px solid #f5f5f5;
  background-color: #fdfdfd;
}
.sub-detail-text {
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: #989898;
}
</style>
